import React from "react";
import Wrapper from "./_Wrapper";
import AiChatRB from "../components/aiChatbotRB";

export default function AiChatPage({ className, label, value, color = "initial", loadingState=false, width }) {
  return (
    <Wrapper>
        <AiChatRB />
    </Wrapper>
  );
}
